<app-confirm 
    (confirmationResult)="onConfirmationResult($event)"
></app-confirm>
